


















































































































































































































































































































































































import CardPanel from '@/components/common/CardPanel.vue'
import { ElForm } from 'element-ui/types/form'
import { Component, Ref, Vue } from 'vue-property-decorator'
import SimpleUploader from "@/components/common/SimpleUploader.vue"
import { getDataContent } from '@/request/apis/common'
import { createTask } from '@/request/apis/PreProcessingRequest'
import ParamsDialogWrapper from "@/components/common/ParamsDialogWrapper.vue"
import CascaderSelect from "@/components/common/CascaderSelect.vue";

@Component({
  components: {
    CascaderSelect,
    CardPanel,
    SimpleUploader,
    ParamsDialogWrapper
  }
})
export default class PreProcessingForm extends Vue {
  @Ref('form') readonly submitForm!: ElForm
  @Ref('textarea') readonly textarea!: HTMLInputElement

  private loadingProcessButton: boolean = false
  private type: string = 'PreProcessing'
  private saveParams: object = {}
  private filterName: string = ''
  private form: any = {
    inputType: 'choose', // choose | file
    chooseData: '', // 选择的数据
    dataID: '', //上传的文件ID
    content: '', // 文本内容
    isConsiderBatch: 'False', // consider_batch, True | False
    isConsiderNorm: 'True', // consider_normalization, True | False
    batchName: 'Channel',
    minGenes: -1,
    maxGenes: -1,
    minUmis: -1,
    maxUmis: -1,
    mitoPrefix: 'None',
    percentMito: -1,
    normCount: 100000,
    nTop: 2000,
    minDisp: 0.5,
    maxDisp: -1,
    minMean: 0.0125,
    maxMean: 7,
    nComponents: 50,
    maxValue: 10,
    numberOfNeighbors: 100,
    rep: 'pca',
    randomState: 0
  }

  get id() {
    return this.$route.params.id
  }

  /**
   * 级联选择器数据改变
   */
  private async handleDataChange(value: string) {
    this.form.chooseData = value
    await this.getContent()
  }

  /**
   * 根据选择数据获取文本内容
   */
  private async getContent () {
    const res = await getDataContent(this.textarea, this.form.chooseData).start()
    this.form.content = res.content
  }

  /**
   * 返回过滤后的数据
   */
  private filterHandler (e: any) {
    this.saveParams = e.params
    this.filterName = e.filterName
  }

  /**
   * 表单提交
   */
  private submitHandler () {
    this.submitForm.validate(async (valid) => {
      if (valid) {
        this.loadingProcessButton = true
        try {
          let params: any = {
            min_genes: this.form.minGenes,
            max_genes: this.form.maxGenes,
            min_umis: this.form.minUmis,
            max_umis: this.form.maxUmis,
            mito_prefix: this.form.mitoPrefix,
            percent_mito: this.form.percentMito,
            consider_norm: this.form.isConsiderNorm,
            consider_batch: this.form.isConsiderBatch,
            n_top: this.form.nTop,
            min_disp: this.form.minDisp,
            max_disp: this.form.maxDisp,
            min_mean: this.form.minMean,
            max_mean: this.form.maxMean,
            n_components: this.form.nComponents,
            max_value: this.form.maxValue,
            number_neighbors: this.form.numberOfNeighbors,
            rep: this.form.rep,
            random_state: this.form.randomState,
            filter: JSON.stringify(this.saveParams),
            filter_name: this.filterName
          }
          if (this.form.isConsiderBatch === 'True') {
            params.batch_name = this.form.batchName
          }
          if (this.form.isConsiderNorm === 'True') {
            params.norm_count = this.form.normCount
          }
          if (this.form.inputType === 'file') {
            params.choose_data = this.form.dataID
          } else {
            params.choose_data = this.form.chooseData
          }
          const taskDetail = await createTask(null, params).start()
          this.$emit('formSubmit', taskDetail)
        } catch (e) {
          console.warn(e)
        }
        this.loadingProcessButton = false
      } else {
        return false
      }
    })
  }

  private get rules () {
    const checkInputData = (rule: any, value: string, callback: Function) => {
      if (this.form.inputType === 'choose' && !value) {
        return callback(new Error(<string>this.$t('form.choose')))
      }
      callback()
    }
    const checkFile = (rule: any, value: string, callback: Function) => {
      if (this.form.inputType === 'file' && !this.form.dataID) {
        return callback(new Error(<string>this.$t('form.upload')))
      }
      callback()
    }
    const checkMinGenes = (rule: any, value: number, callback: Function) => {
      if ((this.form.minGenes < 0 || this.form.minGenes > 30000) && this.form.minGenes != -1) {
        return callback(new Error(<string>this.$t('form.params.preProcessing.checkMinGenes')))
      }
      callback()
    }
    const checkMaxGenes = (rule: any, value: number, callback: Function) => {
      if ((this.form.maxGenes < 0 || this.form.maxGenes > 90000) && this.form.maxGenes != -1) {
        return callback(new Error(<string>this.$t('form.params.preProcessing.checkMaxGenes')))
      }
      callback()
    }
    const checkNormCount = (rule: any, value: number, callback: Function) => {
      if ((this.form.normCount < 100 || this.form.normCount > 100000) && this.form.consider_norm === 'True') {
        return callback(new Error(<string>this.$t('form.params.preProcessing.checkNormCount')))
      }
      callback()
    }
    const checkNTop = (rule: any, value: number, callback: Function) => {
      if (this.form.nTop < 100 || this.form.nTop > 20000) {
        return callback(new Error(<string>this.$t('form.params.preProcessing.checkNTop')))
      }
      callback()
    }
    const checkMinMean = (rule: any, value: number, callback: Function) => {
      if (this.form.minMean < 0.0001 || this.form.minMean > 1) {
        return callback(new Error(<string>this.$t('form.params.preProcessing.checkMinMean')))
      }
      callback()
    }
    const checkMaxMean = (rule: any, value: number, callback: Function) => {
      if (this.form.maxMean < 1 || this.form.maxMean > 100) {
        return callback(new Error(<string>this.$t('form.params.preProcessing.checkMaxMean')))
      }
      callback()
    }
    const checkNumberOfNeighbors = (rule: any, value: number, callback: Function) => {
      if (this.form.numberOfNeighbors < 1 || this.form.numberOfNeighbors > 10000) {
        return callback(new Error(<string>this.$t('form.params.preProcessing.checkNumberOfNeighbors')))
      }
      callback()
    }
    const checkNComponents = (rule: any, value: number, callback: Function) => {
      if (this.form.nComponents < 1 || this.form.nComponents > 1000) {
        return callback(new Error(<string>this.$t('form.params.preProcessing.checkNComponents')))
      }
      callback()
    }
    const checkMaxValue = (rule: any, value: number, callback: Function) => {
      if (this.form.maxValue < 1 || this.form.maxValue > 1000) {
        return callback(new Error(<string>this.$t('form.params.preProcessing.checkMaxValue')))
      }
      callback()
    }
    const checkMinUmis = (rule: any, value: number, callback: Function) => {
      if (value == null) {
        return callback(new Error(<string>this.$t('form.params.checkParams')))
      }
      callback()
    }
    const checkMaxUmis = (rule: any, value: number, callback: Function) => {
      if (value == null) {
        return callback(new Error(<string>this.$t('form.params.checkParams')))
      }
      callback()
    }
    const checkBatchName = (rule: any, value: number, callback: Function) => {
      if (!value && this.form.isConsiderBatch === 'True') {
        return callback(new Error(<string>this.$t('form.params.checkParams')))
      }
      callback()
    }
    const checkMitoPremix = (rule: any, value: number, callback: Function) => {
      if (!value) {
        return callback(new Error(<string>this.$t('form.params.checkParams')))
      }
      callback()
    }
    const checkPercentMito = (rule: any, value: number, callback: Function) => {
      if (value == null) {
        return callback(new Error(<string>this.$t('form.params.checkParams')))
      }
      callback()
    }
    const checkMinDisp = (rule: any, value: number, callback: Function) => {
      if (value == null) {
        return callback(new Error(<string>this.$t('form.params.checkParams')))
      }
      callback()
    }
    const checkMaxDisp = (rule: any, value: number, callback: Function) => {
      if (value == null) {
        return callback(new Error(<string>this.$t('form.params.checkParams')))
      }
      callback()
    }
    const checkRep = (rule: any, value: number, callback: Function) => {
      if (!value) {
        return callback(new Error(<string>this.$t('form.params.checkParams')))
      }
      callback()
    }
    const checkRandomState = (rule: any, value: number, callback: Function) => {
      if (value == null) {
        return callback(new Error(<string>this.$t('form.params.checkParams')))
      }
      callback()
    }
    return {
      chooseData: [
        { validator: checkInputData, trigger: 'change' }
      ],
      fileId: [
        { validator: checkFile, trigger: 'change' }
      ],
      minGenes: [
        { validator: checkMinGenes, trigger: 'change' }
      ],
      maxGenes: [
        { validator: checkMaxGenes, trigger: 'change' }
      ],
      normCount: [
        { validator: checkNormCount, trigger: 'change' }
      ],
      nTop: [
        { validator: checkNTop, trigger: 'change' }
      ],
      minMean: [
        { validator: checkMinMean, trigger: 'change' }
      ],
      maxMean: [
        { validator: checkMaxMean, trigger: 'change' }
      ],
      numberOfNeighbors: [
        { validator: checkNumberOfNeighbors, trigger: 'change' }
      ],
      nComponents: [
        { validator: checkNComponents, trigger: 'change' }
      ],
      batchName: [
        { validator: checkBatchName, trigger: 'change' }
      ],
      maxValue: [
        { validator: checkMaxValue, trigger: 'change' }
      ],
      minUmis: [
        { validator: checkMinUmis, trigger: 'change' }
      ],
      maxUmis: [
        { validator: checkMaxUmis, trigger: 'change' }
      ],
      mitoPrefix: [
        { validator: checkMitoPremix, trigger: 'change' }
      ],
      percentMito: [
        { validator: checkPercentMito, trigger: 'change' }
      ],
      minDisp: [
        { validator: checkMinDisp, trigger: 'change' }
      ],
      maxDisp: [
        { validator: checkMaxDisp, trigger: 'change' }
      ],
      rep: [
        { validator: checkRep, trigger: 'change' }
      ],
      randomState: [
        { validator: checkRandomState, trigger: 'change' }
      ]
    }
  }
}
